var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom d-inline"},[_c('bee-label',{staticClass:"custom d-inline",attrs:{"color":_vm.localColor,"bold":true,"content":_vm.content,"empty-state":_vm.emptyState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }